import { render, staticRenderFns } from "./mybook.vue?vue&type=template&id=c53ebb26&scoped=true&"
import script from "./mybook.vue?vue&type=script&lang=js&"
export * from "./mybook.vue?vue&type=script&lang=js&"
import style0 from "./mybook.vue?vue&type=style&index=0&id=c53ebb26&prod&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c53ebb26",
  null
  
)

export default component.exports